function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}


function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
  Motion, announcements and overlays: docs/UI-MAP.md 3.7 describes how to use them.
  reducedMotion() follows the setting live (reducedMotionQuery fires `change`); scripts check it
  before any motion they run themselves. scrollBehavior() is the `behavior` for scrolling.
*/
const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

function reducedMotion() {
  return reducedMotionQuery.matches;
}

function scrollBehavior() {
  return reducedMotion() ? 'auto' : 'smooth';
}

/*
  afterPaint(fn): runs fn once the frame the tap started has painted (d-40, INP). An overlay opened in
  the tap's own task makes the tap wait for the overlay's whole first layout (the cart and menu took
  280-500 ms); painted first, the tap answers at once and the overlay follows a frame later.
*/
function afterPaint(fn) {
  requestAnimationFrame(() => setTimeout(fn));
}

/*
  cssTime(value, fallback): a CSS time token in ms. The CDN minifies CSS, so 600ms arrives as .6s;
  read the unit (d-40), else the fallback.
*/
function cssTime(value, fallback) {
  const text = String(value).trim();
  const number = parseFloat(text);
  if (Number.isNaN(number)) return fallback;
  return text.endsWith('ms') ? number : number * 1000;
}

/*
  Overlays.open(element, { name, opener, hide }) and Overlays.close(element): one modal <dialog> at
  a time (or a toast, toggled by [hidden]), Escape closes the top one, focus goes back along the
  openers, modals lock scroll and set html[data-overlay]. announce(message) speaks through the one
  status region, #Announcer, which sits in the open modal while there is one (the rest is inert).
*/
const Overlays = (() => {
  const stack = [];
  // Array.prototype.findLast is missing before Safari 15.4: search from the end by hand.
  const last = (test) => {
    for (let i = stack.length - 1; i >= 0; i--) if (test(stack[i])) return stack[i];
  };
  const root = document.documentElement;
  let locks = 0;
  let message = null;
  let messageTimer;

  const find = (element) => stack.find((entry) => entry.element === element);
  const isShut = (element) => (element.tagName === 'DIALOG' ? !element.open : element.hidden);
  // focus() does nothing on what is gone, hidden, inert or disabled.
  const focusOn = (element) => element?.isConnected && (element.focus(), document.activeElement === element);

  // Where the status region belongs: the top modal, else a modal opened without Overlays, else the
  // page. Nowhere while the top modal is closing.
  function regionHome() {
    const top = last((entry) => entry.modal);
    if (top) return top.closing ? null : top.element;
    let modal = null;
    try {
      modal = document.querySelector('dialog:modal');
    } catch (error) {}
    return modal || document.body;
  }

  function placeRegion() {
    const home = regionHome();
    if (!home) return;
    let region = document.getElementById('Announcer');
    if (!region) {
      region = document.createElement('p');
      region.id = 'Announcer';
      region.className = 'visually-hidden';
      region.setAttribute('role', 'status');
    }
    if (region.parentNode !== home) {
      region.textContent = '';
      home.append(region);
    }
    if (message === null) return;
    const text = message;
    message = null;
    region.textContent = '';
    clearTimeout(messageTimer);
    messageTimer = setTimeout(() => (region.textContent = text), 100);
  }

  function sync() {
    const top = last((entry) => entry.modal);
    if (locks > 0 && top) root.dataset.overlay = top.name;
    else delete root.dataset.overlay;
    placeRegion();
  }

  function requestClose(entry) {
    if (entry.closing) return;
    entry.closing = true;
    sync();
    if (entry.hide) entry.hide();
    else if (entry.modal) entry.element.close();
    else entry.element.hidden = true;
  }

  // The overlay has shut, however it closed.
  function settle(element) {
    const index = stack.findIndex((entry) => entry.element === element);
    if (index < 0) return;
    const [entry] = stack.splice(index, 1);
    if (entry.modal) locks = Math.max(0, locks - 1);
    const active = document.activeElement;
    if (!entry.handedOver && (!active || active === document.body || element.contains(active))) {
      entry.returnTo.some(focusOn);
    }
    sync();
  }

  const observer = new MutationObserver((records) =>
    records.forEach(({ target }) => isShut(target) && settle(target))
  );

  function onCancel(event) {
    const entry = find(event.currentTarget);
    if (!entry || !event.cancelable) return;
    event.preventDefault();
    requestClose(entry);
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || event.defaultPrevented || event.isComposing) return;
    const top = last((entry) => !entry.closing);
    if (!top) return;
    // Stops the browser's own close, so the overlay closes its way (and Escape does nothing else).
    if (top.modal) event.preventDefault();
    requestClose(top);
  });

  function open(element, { name, opener = document.activeElement, hide } = {}) {
    const existing = find(element);
    if (existing) {
      // Opened again while closing: it stays.
      existing.closing = existing.handedOver = false;
      sync();
      return;
    }
    const modal = element.tagName === 'DIALOG';
    const holder = last((entry) => entry.element.contains(opener));
    const entry = { element, name: name || element.id || 'overlay', modal, hide };
    entry.returnTo = [opener, ...(holder ? holder.returnTo : [])];
    if (modal) {
      // Shown first: if it can't open, nothing is locked.
      if (!element.open) element.showModal();
      const current = last((other) => other.modal && !other.closing);
      if (current) {
        if (current !== holder) entry.returnTo.push(...current.returnTo);
        current.handedOver = true;
        requestClose(current);
      }
      locks += 1;
      element.addEventListener('cancel', onCancel);
    } else {
      element.hidden = false;
    }
    stack.push(entry);
    observer.observe(element, { attributes: true, attributeFilter: ['open', 'hidden'] });
    sync();
  }

  function close(element) {
    const entry = find(element);
    if (entry) requestClose(entry);
  }

  function announce(text) {
    message = String(text);
    placeRegion();
  }

  return { open, close, announce };
})();

function announce(message) {
  Overlays.announce(message);
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => {
        deferredElement.setAttribute('style', formerStyle);
      }, 0);
    }
  }
}

if (!customElements.get('deferred-media')) {
  customElements.define('deferred-media', DeferredMedia);
}

/*
  Product recommendations ("goes with", sections/related-products.liquid). Fetches its section from the
  Product Recommendations API a screen before it scrolls into view, so the cards are in place before
  they're seen, and swaps in the rendered row. With nothing to recommend it removes itself, so the row
  stays hidden.
*/
class ProductRecommendations extends HTMLElement {
  observer = undefined;

  connectedCallback() {
    this.observer?.disconnect();
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        this.loadRecommendations();
      },
      { rootMargin: '0px 0px 100% 0px' }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  loadRecommendations() {
    fetch(`${this.dataset.url}&product_id=${this.dataset.productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        // An inert document: nothing in the response loads or runs until it's swapped in.
        const html = new DOMParser().parseFromString(text, 'text/html');
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        } else {
          this.remove();
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}
